import { SUPER_ADMIN_DOMAIN } from './constant';

export const SUPER_ADMIN_ROLE = {
  id: 1,
  role_name: 'Super admin',
  description: 'Super Administrator with the highest privileges',
  color: 'error',
  class: 'border-[#F9A825] text-[#F9A825]',
};

const rolesMapping = {
  1: SUPER_ADMIN_ROLE,
  2: {
    id: 2,
    role_name: 'Admin',
    description: 'Administrator with full access to all features',
    color: 'primary',
    class: 'border-[#00D68F] text-[#00D68F]',
  },
  3: {
    id: 3,
    role_name: 'User',
    description: 'Standard user with limited access',
    color: 'secondary',
    class: 'border-[#3546FF] text-[#3546FF]',
  },
};

const DOMAIN_ROLES = {
  ADMIN: rolesMapping[2].role_name,
  USER: rolesMapping[3].role_name,
};

export const checkIfUserAdminOrSuperAdmin = (user) =>
  user?.userDomains?.some(
    (domain) =>
      domain?.domainName === SUPER_ADMIN_DOMAIN ||
      domain?.role?.role_name === DOMAIN_ROLES.ADMIN ||
      domain?.role === DOMAIN_ROLES.ADMIN
  ) || false;

export const isUserAdminOfDomain = (user, domainName, domainId) => {
  if (!user?.userDomains?.length || !domainName) return false;
  return user.userDomains.some((domain) => {
    const isSameDomain =
      domain?.domainName === domainName ||
      (domainId != null &&
        (String(domain?.domainId) === String(domainId) || String(domain?.id) === String(domainId)));
    const isAdminOrSuperAdmin =
      domain?.domainName === SUPER_ADMIN_DOMAIN ||
      domain?.role?.role_name === DOMAIN_ROLES.ADMIN ||
      domain?.role?.role_name === SUPER_ADMIN_ROLE.role_name ||
      domain?.role === DOMAIN_ROLES.ADMIN ||
      domain?.role?.id === 1 ||
      domain?.role?.id === 2;
    return isSameDomain && isAdminOrSuperAdmin;
  });
};

export default rolesMapping;
